import { LegalDocumentPage } from '../Legal/LegalDocumentPage'
import { privacyContent } from '../Legal/privacyContent'

export const Privacy = () => <LegalDocumentPage content={privacyContent} />
